import { Api } from '@vendor/js/api';
import { Spinner } from '@vendor/js/spinner';
import Common from '@vendor/js/common';
import { Swal } from '@vendor/libs/sweetalert2/sweetalert2';
const _ChooseAssociationUserModalHandler = (function () {
    return {
        // Public functions
        init: function () {
            const openModalButton = $('[data-bs-target="#choose_user_from_association_modal"]');
            const form = $(openModalButton).closest('form');
            const regionId = $(openModalButton).attr('data-region_id') ?? null;
            const modal = $('#choose_user_from_association_modal');
            const associationSelect = modal.find('[name="associations_select"]');
            const associationUsersSelect = modal.find('[name="association_users_select"]');
            const userDataMap = new Map();
            $(openModalButton).on('click', async function () {
                const spinner = new Spinner();
                try {
                    const response = await Api.get(`/regions/${regionId}/associations`);
                    associationSelect.empty();
                    if (response.data.associations.length === 0) {
                        Swal.fire({
                            text: 'Brak kół do wyboru.',
                            icon: 'error',
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        }).then(() => {
                            if (modal != null) {
                                Common.closeModal(modal);
                            }
                        });
                    }
                    Common.fillFormElement(form, 'associations_select', response.data.associations);
                    associationSelect.trigger('change');
                }
                catch (err) {
                    Common.handleErrorResponse(err);
                }
                finally {
                    spinner.destroy();
                }
            });
            $(associationSelect).on('change', async function () {
                const spinner = new Spinner();
                const associationId = associationSelect.val();
                try {
                    if (!associationId) {
                        return;
                    }
                    const response = await Api.get(`/regions/${regionId}/associations/${associationId}/unassigned-users`);
                    if (response.data.users.length === 0) {
                        Swal.fire({
                            text: 'Brak użytkowników do wyboru.',
                            icon: 'error',
                            buttonsStyling: false,
                            reverseButtons: true,
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                        }).then(() => {
                            if (modal != null) {
                                Common.closeModal(modal);
                            }
                        });
                    }
                    associationUsersSelect.empty();
                    console.log(response.data.users);
                    const formattedUsers = response.data.users.map((user) => ({
                        ...user,
                        name: `${user.first_name} ${user.last_name}`,
                    }));
                    for (const user of response.data.users) {
                        userDataMap.set(user.id, user);
                    }
                    console.log(formattedUsers);
                    Common.fillFormElement(form, 'association_users_select', formattedUsers);
                    associationUsersSelect.trigger('change');
                }
                catch (err) {
                    Common.handleErrorResponse(err);
                }
                finally {
                    spinner.destroy();
                }
            });
            modal
                .find(`[data-app-${modal.attr('id')}-action="cancel"]`)
                .on('click', function () {
                Common.closeModal(modal);
            });
            modal
                .find(`[data-app-${modal.attr('id')}-action="submit"]`)
                .on('click', function () {
                if (!associationUsersSelect.val()) {
                    return;
                }
                const selectedUserId = associationUsersSelect.val();
                if (!selectedUserId) {
                    return;
                }
                const selectedUser = userDataMap.get(Number(selectedUserId));
                if (!selectedUser) {
                    return;
                }
                // Disable and clear specific fields
                ['password'].forEach((field) => {
                    const input = $(`[name="${field}"]`);
                    input.val('').prop('disabled', true).prop('require', false);
                });
                // Fill form fields with selected user data
                Object.keys(selectedUser).forEach((field) => {
                    if (field === 'phone_number') {
                        selectedUser[field] = selectedUser[field].trim();
                    }
                    $(`[name="${field}"]`).val(selectedUser[field]);
                });
                Common.closeModal(modal);
            });
        },
    };
})();
window.ChooseAssociationUserModalHandler = _ChooseAssociationUserModalHandler;
